module.exports = __webpack_public_path__ + "76408bce182f1264ee3294d163e94402.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_10.jpg
 ** module id = 592
 ** module chunks = 0
 **/